import { render } from "./SpacesSettleTeam.vue?vue&type=template&id=368242f0&scoped=true&ts=true"
import script from "./SpacesSettleTeam.vue?vue&type=script&lang=ts"
export * from "./SpacesSettleTeam.vue?vue&type=script&lang=ts"

import "./SpacesSettleTeam.vue?vue&type=style&index=0&id=368242f0&lang=sass&scoped=true"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-368242f0"]])

export default __exports__